<h2 mat-dialog-title>{{ 'SYNC.title' | translate }}</h2>

@if (syncing()) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-dialog-content>
  @if (results() === null) {
    <p class="hint">{{ 'SYNC.description' | translate }}</p>

    <div class="warning">
      <mat-icon>info</mat-icon>
      <span>{{ 'SYNC.oneWayWarning' | translate }}</span>
    </div>

    <p class="source">
      {{ 'SYNC.source' | translate }}: <strong>{{ session.name }}</strong>
    </p>

    @if (storedTarget(); as target) {
      <p class="source">
        {{ 'SYNC.target' | translate }}: <strong class="target">{{ target }}</strong>
        <br />
        <small>{{ 'SYNC.targetStoredHint' | translate }}</small>
      </p>
    } @else if (status() !== undefined) {
      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ 'SYNC.targetLabel' | translate }}</mat-label>
        <input
          matInput
          [formControl]="targetControl"
          [placeholder]="'SYNC.targetPlaceholder' | translate"
        />
        @if (targetControl.touched && targetControl.invalid) {
          <mat-error>{{ 'SYNC.targetRequired' | translate }}</mat-error>
        }
        <mat-hint>{{ 'SYNC.targetHint' | translate }}</mat-hint>
      </mat-form-field>
    }

    @if (status(); as s) {
      <div class="status">
        <p>
          @if (s.lastSyncedAt) {
            {{ 'SYNC.STATUS.lastSync' | translate: { date: (s.lastSyncedAt | date: 'short') } }}
          } @else {
            {{ 'SYNC.STATUS.never' | translate }}
          }
        </p>
        <ul class="counts">
          <li><strong>{{ s.counts.new }}</strong> {{ 'SYNC.STATUS.new' | translate }}</li>
          <li><strong>{{ s.counts.changed }}</strong> {{ 'SYNC.STATUS.changed' | translate }}</li>
          <li><strong>{{ s.counts.toExit }}</strong> {{ 'SYNC.STATUS.toExit' | translate }}</li>
          <li><strong>{{ s.counts.unchanged }}</strong> {{ 'SYNC.STATUS.unchanged' | translate }}</li>
          @if (s.counts.notRecruiting) {
            <li>
              <strong>{{ s.counts.notRecruiting }}</strong>
              {{ 'SYNC.STATUS.notRecruiting' | translate }}
            </li>
          }
        </ul>
      </div>
    }
  } @else {
    <div class="lineage">
      <mat-icon>sync</mat-icon>
      <span>
        {{
          'SYNC.lineage'
            | translate: { target: targetSessionId(), date: (syncedAt() | date: 'short') }
        }}
      </span>
    </div>

    @if (summary(); as s) {
      <p class="summary">
        {{
          'SYNC.summary'
            | translate
              : {
                  total: s.total,
                  created: s.created,
                  updated: s.updated,
                  unchanged: s.unchanged,
                  exited: s.exited,
                  skipped: s.skipped,
                  failed: s.failed
                }
        }}
      </p>
    }

    @if (results()!.length === 0) {
      <p class="empty">{{ 'SYNC.noStops' | translate }}</p>
    } @else {
      <ul class="results">
        @for (r of results()!; track r.stopId) {
          <li [class.failed]="r.status === 'error'">
            <mat-icon>{{ icon(r.status) }}</mat-icon>
            <span class="id">{{ r.name ?? r.stopId }}</span>
            <span class="status">{{ statusKey(r.status) | translate }}</span>
            @if (r.error) {
              <span class="msg">{{ r.error }}</span>
            }
          </li>
        }
      </ul>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (results() === null) {
    <button mat-button type="button" (click)="close()">
      {{ 'SYNC.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="syncing() || status() === undefined"
      (click)="submit()"
    >
      {{ 'SYNC.startBtn' | translate }}
    </button>
  } @else {
    <button mat-flat-button color="primary" type="button" (click)="close()">
      {{ 'SYNC.close' | translate }}
    </button>
  }
</mat-dialog-actions>
